import { render, staticRenderFns } from "./new_digital_asset.vue?vue&type=template&id=56e42375&scoped=true"
import script from "./new_digital_asset.vue?vue&type=script&lang=js"
export * from "./new_digital_asset.vue?vue&type=script&lang=js"
import style0 from "./new_digital_asset.vue?vue&type=style&index=0&id=56e42375&prod&scoped=true&lang=css"
import style1 from "./new_digital_asset.vue?vue&type=style&index=1&id=56e42375&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e42375",
  null
  
)

export default component.exports